// src/components/products/CRMWidget.js
import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import crm1 from '../../images/crm/2.png';
import crm2 from '../../images/crm/3.png';
import crm3 from '../../images/crm/4.png'; // add more as needed


const images = [crm1, crm2, crm3];

const CRMWidget = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div className="crm-widget mb-4">
      <h5 className="mb-3">CRM Screenshots</h5>
      <div className="d-flex flex-wrap gap-4">
        {images.map((img, idx) => (
          <img
            key={idx}
            src={img}
            alt={`CRM ${idx + 1}`}
            style={{ width: '370px', height: '150px', objectFit: 'cover', cursor: 'pointer', borderRadius: 8 ,  border: '2px solid black' }}
            onClick={() => setSelectedImage(img)}
          />
        ))}
      </div>

      <Modal show={!!selectedImage} onHide={() => setSelectedImage(null)} centered size="xl">
        <Modal.Body className="text-center p-0">
          {selectedImage && <img src={selectedImage} alt="CRM Preview" style={{ width: '100%', height: 'auto' }} />}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CRMWidget;
